<template>
  <footer
    class="app-footer"
    id="app-footer"
  >
    <CadyFooter
      :nav-items="footerNavContent"
      show-help
      :help-url="helpUrl"
    />
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useAppContentStore } from '@/stores/appContent'
import { mapState } from 'pinia'

import { CadyFooter } from '@VelocitySquared/cady-design-system'

export default defineComponent({
  name: 'AppFooter',
  components: {
    CadyFooter
  },
  computed: {
    ...mapState(useAppContentStore, ['footerNavContent']),
    helpUrl(): string {
      return import.meta.env.VITE_CADY_HELP_URL
    }
  }
})
</script>

<style lang="scss" scoped>
.app-footer {
  background: #000;
  color: #fff;
  padding-bottom: 6rem;

  @include media-breakpoint-up(lg) {
    padding-bottom: 4rem;
  }

  &__second-bar {
    height: 40px;
    background: linear-gradient(90deg, #514c9a, #ad4091);
  }
  &__tag-line {
    font-family: 'Neue Haas Grotesk Display Pro Medium', Helvetica, Arial, sans-serif;
    font-size: 1.75rem;
    font-weight: 500;
    line-height: 117%;
    color: #fff;
  }
  .nav-link {
    color: white;
  }

  .nav-item {
    border: none !important;
  }

  // Terms link: no underline by default, underline on hover only (the design
  // system leaves it underlined via the default anchor styling).
  :deep(.cady-footer__terms-link) {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  // Footer nav items: space them out while the nav is stacked; the design-system
  // nav goes horizontal at lg, so reset the margin there.
  :deep(.cady-footer-primary-nav__item) {
    margin-bottom: 1rem;

    @include media-breakpoint-up(lg) {
      margin-bottom: 0;
    }
  }
}
</style>
